import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SHEIN_TEMPLATE_SCOPES,
  resolveVisibleSheinTemplateScopes,
} from '@/shein-platform/constants/sheinTemplateScope';

const SCOPE_LABEL_KEYS = {
  '单店铺独享': 'scopePersonal',
  '团队店铺共享': 'scopeTeam',
  '官方': 'scopeOfficial',
};

/**
 * 模板库单店铺独享 / 团队店铺共享 / 官方 Tab（商品 / 属性 / 尺码 / 实拍图 / 证书共用）。
 * 团队店铺共享 Tab 仅在有团队权限时展示。
 */
export default function SheinTemplateScopeTabs({
  scopeTab,
  canAccessTeam = false,
  disabled = false,
  ariaLabel,
  tabs,
  className = '',
  onChange,
}) {
  const { t } = useTranslation('workbench');
  const list = Array.isArray(tabs) && tabs.length
    ? tabs.filter((tab) => tab.id !== SHEIN_TEMPLATE_SCOPES.team || Boolean(canAccessTeam))
    : resolveVisibleSheinTemplateScopes(canAccessTeam);
  return (
    <div
      className={['spo-status-tabs', className].filter(Boolean).join(' ')}
      role="tablist"
      aria-label={ariaLabel || t('productTemplate.scopeAriaShort')}
    >
      {list.map((tab) => {
        const active = scopeTab === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`spo-status-tab${active ? ' spo-status-tab--active' : ''}`}
            disabled={disabled}
            onClick={() => {
              if (scopeTab === tab.id) return;
              onChange?.(tab.id);
            }}
          >
            {SCOPE_LABEL_KEYS[tab.label] ? t(`productTemplate.${SCOPE_LABEL_KEYS[tab.label]}`) : tab.label}
          </button>
        );
      })}
    </div>
  );
}
